export interface FileType {
  id: number;
  name: string | null;
}

export enum FileTypeEnums {
  Photo = 1,
  Manual = 2,
  Warranty = 3,
  Brochure = 4,
}
